import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-inventorymovement',
  templateUrl: './inventorymovement.component.html',
  styleUrls: ['./inventorymovement.component.scss']
})
export class InventorymovementComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
